(function ($) {
  var elementorHookRegistered = false;
  var widgetSelector = '[data-plan-3d]';

  function getPlan3dWidgets($scope) {
    if ($scope.is(widgetSelector)) {
      return $scope;
    }

    return $scope.find(widgetSelector);
  }

  function initPlan3d($scope) {
    getPlan3dWidgets($scope).each(function () {
      var $plan3d = $(this);

      if ($plan3d.data('plan3dInitialized')) {
        return;
      }

      $plan3d.data('plan3dInitialized', true);

      $plan3d.on('click.plan3d', function () {
        $(this).addClass('active');
      });

      $plan3d.on('mouseleave.plan3d', function () {
        $(this).removeClass('active');
      });
    });
  }

  function registerElementorHook() {
    if (
      elementorHookRegistered ||
      !window.elementorFrontend ||
      !window.elementorFrontend.hooks
    ) {
      return;
    }

    elementorHookRegistered = true;

    window.elementorFrontend.hooks.addAction(
      'frontend/element_ready/plan-3d.default',
      initPlan3d
    );
  }

  $(window).on('elementor/frontend/init', registerElementorHook);

  $(function () {
    registerElementorHook();
    initPlan3d($(document));
  });
})(jQuery);
